import { render, staticRenderFns } from "./product-media-tab.vue?vue&type=template&id=314ef7db"
import script from "./product-media-tab.vue?vue&type=script&lang=js"
export * from "./product-media-tab.vue?vue&type=script&lang=js"
import style0 from "./product-media-tab.vue?vue&type=style&index=0&id=314ef7db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports